import React from "react";
import PageHeader from "../../../../components/headers/PageHeader";
import castel from "../../../../assets/Images/castel.jpg";
import "./Usfda.css";
import { Link } from "react-router-dom";
import Flag from "react-world-flags";

export default function Usfda() {
    return (
        <div className="usfda-page">
            <PageHeader
                mediaSrc={castel}
                mediaType="image"
                title="US FDA 510(k) Consultant"
                slogan=""
            />

            <section className="usfda-section usfda-introSection">
                <h2>US FDA Medical Device Regulatory Support</h2>

                <p>
                    The United States Food and Drug Administration regulates medical
                    devices through a structured framework that includes device
                    classification, establishment registration, device listing, premarket
                    notification, De Novo classification requests, and premarket approval
                    where applicable. For manufacturers entering the US market, selecting
                    the correct regulatory pathway is critical for avoiding delays and
                    preparing a complete submission.
                </p>

                <p>
                    Eupraxia supports medical device companies with practical US FDA
                    regulatory consulting, including 510(k) strategy, predicate device
                    assessment, substantial equivalence documentation, QMS alignment,
                    technical file preparation, FDA communication support, and lifecycle
                    regulatory maintenance.
                </p>
            </section>

            <section className="usfda-section">
                <h2>US FDA 510(k), De Novo, and Premarket Approval Support</h2>

                <p>
                    Medical devices intended for the US market may require 510(k)
                    clearance, De Novo classification, Premarket Approval, establishment
                    registration, or device listing depending on the device type, risk
                    profile, intended use, and predicate availability. Our team helps
                    assess the appropriate pathway and prepare submission-ready
                    documentation aligned with FDA expectations.
                </p>
            </section>

            <section className="usfda-section usfda-servicesSection">
                <h2>Our US FDA Services</h2>

                <p className="usfda-sectionIntro">
                    We provide focused regulatory support across the key activities
                    required for US FDA medical device submissions and market access.
                </p>

                <div className="usfda-cardGrid">
                    <article className="usfda-card">
                        <h3>FDA Regulatory Strategy</h3>
                        <p>
                            Interpretation of FDA regulations, device classification,
                            applicable guidance, submission pathway selection, and
                            compliance planning based on device risk, intended use, and
                            market objectives.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>510(k) Submission Documentation</h3>
                        <p>
                            Assistance with compiling the required administrative,
                            technical, performance, labeling, software, biocompatibility,
                            sterilization, and safety documentation for 510(k) submission.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>Predicate Device Identification</h3>
                        <p>
                            Support in identifying suitable predicate devices, reviewing
                            intended use, technological characteristics, indications,
                            performance data, labeling, and regulatory history.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>Substantial Equivalence Assessment</h3>
                        <p>
                            Evaluation and documentation of substantial equivalence between
                            the subject device and predicate device, including comparison
                            tables, differences analysis, and supporting evidence.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>510(k) Technical File Creation</h3>
                        <p>
                            Preparation of structured technical documentation supporting
                            device description, design features, performance testing,
                            labeling, risk controls, standards conformity, and submission
                            traceability.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>FDA Query and Communication Support</h3>
                        <p>
                            Support as a communication bridge during FDA review, including
                            response planning, deficiency management, additional information
                            requests, clarification letters, and submission follow-up.
                        </p>
                    </article>

                    <article className="usfda-card">
                        <h3>21 CFR Part 820 QSR Support</h3>
                        <p>
                            Quality system guidance for manufacturers working toward
                            compliance with FDA Quality System Regulation requirements,
                            including design controls, documentation practices, CAPA,
                            supplier controls, and production controls.
                        </p>
                    </article>
                </div>
            </section>

            <section className="usfda-section usfda-detailSection">
                <h2>How We Support FDA Readiness</h2>

                <div className="usfda-infoGrid">
                    <article className="usfda-infoBox">
                        <h3>Pathway Assessment</h3>
                        <p>
                            We help determine whether the device may follow a 510(k), De
                            Novo, PMA, establishment registration, or device listing route
                            based on classification and intended use.
                        </p>
                    </article>

                    <article className="usfda-infoBox">
                        <h3>Submission Preparation</h3>
                        <p>
                            We organize technical evidence, testing summaries, labeling,
                            device comparisons, administrative forms, and supporting
                            documentation into a clear FDA-ready package.
                        </p>
                    </article>

                    <article className="usfda-infoBox">
                        <h3>Review Support</h3>
                        <p>
                            We support deficiency responses, documentation updates, FDA
                            communication, and lifecycle management after clearance,
                            authorization, or approval.
                        </p>
                    </article>
                </div>
            </section>

            <section className="usfda-section usfda-offerSection">
                <h2>Other Services You May Find Valuable</h2>

                <div className="usfda-regGrid">
                    <Link
                        to="/MedicalDevice/EU"
                        className="usfda-regCard"
                        aria-label="EU MDR"
                    >
                        <header className="usfda-regHead">
                            <Flag code="EU" className="usfda-regFlag" title="European Union" />
                            <h3>EU MDR</h3>
                        </header>

                        <p>
                            CE-marking support under EU MDR 2017/745, including Technical
                            File, Clinical Evaluation Report, and notified body coordination.
                        </p>
                    </Link>

                    <Link
                        to="/MedicalDevice/CDSCO"
                        className="usfda-regCard"
                        aria-label="India CDSCO"
                    >
                        <header className="usfda-regHead">
                            <Flag code="IN" className="usfda-regFlag" title="India" />
                            <h3>India CDSCO</h3>
                        </header>

                        <p>
                            Manufacturing, import, and wholesale licenses, Indian Agent
                            services, and end-to-end dossier preparation.
                        </p>
                    </Link>
                </div>
            </section>
        </div>
    );
}